import { useParams } from "react-router-dom";
import { getSignRequestById } from "../api/signRequests";
import { useEffect, useRef, useState } from "react";
import DatePickerModal from "../components/document/DatePickerModal";
import DocumentUploadModal from "../components/DocumentUploadModal";
import OTPVerificationModal from "../components/OTPVerificationModal";
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  ArrowDownTrayIcon,
} from "@heroicons/react/24/solid";
import {
  XMarkIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  DocumentTextIcon,
  InformationCircleIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { motion } from "framer-motion";
import AnimatedModal from "../components/ui/AnimatedModal";
import { Button } from "../components/ui";
import {
  addWidgetOptions,
  compressedFileSize,
  convertPdfArrayBuffer,
  defaultWidthHeight,
  embedDocId,
  getBase64FromUrl,
  getContainerScale,
  multiSignEmbed,
  onSaveImage,
  onSaveSign,
  pdfNewWidthFun,
  placeholderWidth,
  placeholderHeight,
  radioButtonWidget,
  randomId,
  textWidget,
  textInputWidget,
} from "../utils/general";
import toast from "react-hot-toast";
import PrevNext from "../components/document/PrevNext";
import RenderAllPdfPage from "../components/document/RenderAllPdfPage";
import RenderPdf from "../components/document/RenderPdf";
import { useDrop } from "react-dnd";
import SignPad from "../components/document/SignPad";
import { PDFDocument } from "pdf-lib";
import api from "../utils/axios";
import { useLoading } from "../contexts/LoadingContext";
import { getSignedUrl } from "../utils/signedUrl";

const SignDocument = () => {
  const { signReqId, userId } = useParams();
  const divRef = useRef(null);
  const [signRequest, setSignRequest] = useState(null);
  const [templateData, setTemplateData] = useState(null);
  const [pdfBase64Url, setPdfBase64Url] = useState(null);
  const [pdfArrayBuffer, setPdfArrayBuffer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [signersdata, setSignersData] = useState([]);
  const [signerPos, setSignerPos] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [allPages, setAllPages] = useState(null);
  const [containerWH, setContainerWH] = useState();
  const [pdfNewWidth, setPdfNewWidth] = useState();
  const [isPageCopy, setIsPageCopy] = useState(false);
  const [pdfOriginalWH, setPdfOriginalWH] = useState();
  const [isSignPad, setIsSignPad] = useState(false);
  const [isStamp, setIsStamp] = useState(false);
  const [signKey, setSignKey] = useState(null);
  const [pdfDetails, setPdfDetails] = useState([]);
  const [pdfLoad, setPdfLoad] = useState(false);
  const [signerObjectId, setSignerObjectId] = useState();
  const [signedSigners, setSignedSigners] = useState([]);
  const [isInitial, setIsInitial] = useState(false);
  const [validateAlert, setValidateAlert] = useState(false);
  const [unSignedWidgetId, setUnSignedWidgetId] = useState();
  const [selectWidgetId, setSelectWidgetId] = useState();
  const [currWidgetsDetails, setCurrWidgetsDetails] = useState([]);
  const [isResize, setIsResize] = useState(false);
  const [scale, setScale] = useState(1);
  const [uniqueId, setUniqueId] = useState("");
  const [isAgree, setIsAgree] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [dragKey, setDragKey] = useState();
  const [isTextSetting, setIsTextSetting] = useState(false);
  const [widgetType, setWidgetType] = useState("");
  const [assignedWidgetId, setAssignedWidgetId] = useState("");
  const [requestSignTour, setRequestSignTour] = useState(false);
  const [zIndex, setZIndex] = useState(1);
  const [fontSize, setFontSize] = useState(12);
  const [fontColor, setFontColor] = useState("black");
  const [minRequiredCount, setminRequiredCount] = useState();
  const [signBtnPosition, setSignBtnPosition] = useState([]);
  const [owner, setOwner] = useState({});
  const [saveSignCheckbox, setSaveSignCheckbox] = useState({
    isVisible: false,
    signId: "",
  });
  const [signatureType, setSignatureType] = useState([
    { name: "draw", enabled: true },
    { name: "typed", enabled: true },
    // { name: "upload", enabled: true },
    // { name: "default", enabled: true }
  ]);
  const [isImageSelect, setIsImageSelect] = useState(false);
  const [image, setImage] = useState(null);
  const imageRef = useRef(null);
  const [signature, setSignature] = useState(null);
  const [defaultSignImg, setDefaultSignImg] = useState(null);
  const [myInitial, setMyInitial] = useState(null);
  const [isAutoSign, setIsAutoSign] = useState(false);
  const [imgWH, setImgWH] = useState({});
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showDesktopActionMenu, setShowDesktopActionMenu] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [declineError, setDeclineError] = useState("");
  const [showInfoSidebar, setShowInfoSidebar] = useState(false);
  const [showPagesSidebar, setShowPagesSidebar] = useState(false);
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [showConfirmSignModal, setShowConfirmSignModal] = useState(false);
  const [showDocumentUploadModal, setShowDocumentUploadModal] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [requiresOtp, setRequiresOtp] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [nextWidgetIndex, setNextWidgetIndex] = useState(-1);
  const [nextButtonLabel, setNextButtonLabel] = useState("Next");
  const [recipientPhone, setRecipientPhone] = useState("");
  const [dateModalData, setDateModalData] = useState({
    selectedDate: null,
    onDateChange: null,
    dateFormat: "mm/dd/yyyy",
    fontSize: "14px",
    fontColor: "black",
    allowPastDates: false,
  });
  const [, drop] = useDrop({
    accept: "BOX",
    drop: (item, monitor) => addPositionOfSignature(item, monitor),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
  });

  const { showLoader, hideLoader } = useLoading();

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.tidioChatApi) {
        window.tidioChatApi.hide(); // 👈 Hides the widget button
        clearInterval(interval);
      }
    }, 500);

    return () => {
      window.tidioChatApi.show();
    };
  }, []);

  // console.log("signerPos", signerPos);
  // Function to open date picker modal
  const openDateModal = (
    selectedDate,
    onDateChange,
    dateFormat,
    fontSize,
    fontColor,
    allowPastDates = false,
  ) => {
    setDateModalData({
      selectedDate,
      onDateChange,
      dateFormat: dateFormat || "mm/dd/yyyy",
      fontSize: fontSize || "14px",
      fontColor: fontColor || "black",
      allowPastDates: allowPastDates || false,
    });
    setIsDateModalOpen(true);
  };

  // Function to close date picker modal
  const closeDateModal = () => {
    setIsDateModalOpen(false);
  };

  // Function to find and navigate to next required widget
  const findAndNavigateToNextWidget = (currentWidgetKey, currentPageNumber) => {
    const checkUser = signerPos.filter(
      (data) => data.signerObjId === signerObjectId,
    );

    if (!checkUser || checkUser.length === 0) return;

    const placeholders = checkUser[0].placeHolder;
    let foundCurrent = false;
    let nextWidget = null;
    let nextPage = null;

    // Find the next required widget after the current one
    for (let i = 0; i < placeholders.length; i++) {
      const placeholder = placeholders[i];
      const widgets = placeholder.pos;

      for (let j = 0; j < widgets.length; j++) {
        const widget = widgets[j];

        // Check if this is a required widget
        const isRequired =
          widget.options?.status === "required" ||
          (widget.type === "checkbox" &&
            widget.options?.validation?.minRequiredCount > 0) ||
          (widget.type === radioButtonWidget &&
            widget.options?.status === "required");

        if (!isRequired) continue;

        // Check if widget is filled
        const isFilled =
          widget.options?.response ||
          widget.pos?.SignUrl ||
          widget.options?.defaultValue ||
          (widget.type === "checkbox" &&
            widget.options?.response?.length >=
              widget.options?.validation?.minRequiredCount);

        if (!isFilled) {
          // If we found the current widget, the next unfilled widget is our target
          if (foundCurrent) {
            nextWidget = widget.key;
            nextPage = placeholder.pageNumber;
            break;
          }
        }

        // Mark that we found the current widget
        if (
          widget.key === currentWidgetKey &&
          placeholder.pageNumber === currentPageNumber
        ) {
          foundCurrent = true;
        }
      }

      if (nextWidget) break;
    }

    // If no next widget found after current, look for the first unfilled widget
    if (!nextWidget) {
      for (let i = 0; i < placeholders.length; i++) {
        const placeholder = placeholders[i];
        const widgets = placeholder.pos;

        for (let j = 0; j < widgets.length; j++) {
          const widget = widgets[j];

          const isRequired =
            widget.options?.status === "required" ||
            (widget.type === "checkbox" &&
              widget.options?.validation?.minRequiredCount > 0) ||
            (widget.type === radioButtonWidget &&
              widget.options?.status === "required");

          if (!isRequired) continue;

          const isFilled =
            widget.options?.response ||
            widget.pos?.SignUrl ||
            widget.options?.defaultValue ||
            (widget.type === "checkbox" &&
              widget.options?.response?.length >=
                widget.options?.validation?.minRequiredCount);

          if (!isFilled) {
            nextWidget = widget.key;
            nextPage = placeholder.pageNumber;
            break;
          }
        }

        if (nextWidget) break;
      }
    }

    // Navigate to the next widget
    if (nextWidget && nextPage) {
      setUnSignedWidgetId(nextWidget);
      setSelectWidgetId(nextWidget);
      setPageNumber(nextPage);
      // Close mobile sidebars when auto-navigating
      setShowInfoSidebar(false);
      setShowPagesSidebar(false);
    }
  };

  useEffect(() => {
    const fetchSignRequest = async () => {
      try {
        setIsLoading(true);
        const response = await getSignRequestById(signReqId, userId);

        // Response structure from API:
        // { data: signRequest, requiresOtp: bool, otpVerified: bool, ... }
        const template = response.data || response;

        // Extract OTP-related fields from response (they're at root level)
        const requiresOtpValue = response.requiresOtp || false;
        const otpVerifiedValue = response.otpVerified || false;

        // Check if current recipient requires OTP (per-recipient setting)
        const currentRecipient = template?.recipients?.find(
          (r) => r.contactId === userId,
        );
        const recipientRequiresOTP =
          currentRecipient?.requireOtpVerification || false;

        console.log("OTP Check:", {
          requiresOtpValue,
          otpVerifiedValue,
          recipientRequiresOTP,
          recipient: currentRecipient,
          requiresOtp: response.requiresOtp,
          otpVerified: response.otpVerified,
          fullResponse: response,
        });

        // Use per-recipient OTP requirement if available, otherwise fall back to document-level
        setRequiresOtp(recipientRequiresOTP || requiresOtpValue);
        setOtpVerified(otpVerifiedValue);

        // Find recipient phone number
        if (currentRecipient?.phone) {
          setRecipientPhone(currentRecipient.phone);
        }

        setTemplateData(template);
        const url = template?.signUrl || template?.documentId?.filePath;
        if (url) {
          try {
            const signedUrl = await getSignedUrl(url);
            const arrayBuffer = await convertPdfArrayBuffer(signedUrl);
            const base64Pdf = await getBase64FromUrl(signedUrl);
            if (arrayBuffer === "Error") {
              toast.error("Something went wrong");
            } else {
              setPdfBase64Url(base64Pdf);
              setPdfArrayBuffer(arrayBuffer);
            }
          } catch (error) {
            console.error("Error fetching signed URL:", error);
            toast.error("Failed to load document");
          }
        }
        const RECIPIENT_COLORS_HEX = {
          "bg-blue-500": "#3b82f6",
          "bg-green-500": "#22c55e",
          "bg-yellow-500": "#eab308",
          "bg-purple-500": "#a855f7",
          "bg-pink-500": "#ec4899",
          "bg-indigo-500": "#6366f1",
          "bg-red-500": "#ef4444",
          "bg-teal-500": "#14b8a6",
        };
        const templateRecipients = [...template.recipients];
        const filteredRecipients = templateRecipients.filter(
          (item) => !item.hasSigned,
        );
        const allSigners = filteredRecipients.map((item) => ({
          ...item,
          placeHolder: item?.placeHolder ? item?.placeHolder : [],
          color: RECIPIENT_COLORS_HEX[item.color],
          blockColor: RECIPIENT_COLORS_HEX[item.color],
          Role: item.contactId,
          signerObjId: item.contactId,
          Id: item.contactId,
        }));
        setSignersData(allSigners);
        setSignerPos(allSigners);

        setSignRequest(response.data);
        setIsLoading(false);

        setUniqueId(userId);
        setSignerObjectId(userId);

        // Show OTP modal immediately if OTP is required and not verified
        if (requiresOtpValue && !otpVerifiedValue) {
          setShowOTPModal(true);
        }
      } catch (error) {
        setIsLoading(false);
        setHasError(true);
        setError(error?.message || "Something went wrong");
        setTemplateData(error?.data);
      }
    };

    try {
      fetchSignRequest();
    } catch (error) {
      setHasError(true);
      setError(error?.message || "Something went wrong");
    }
  }, [signReqId, userId]);

  function changePage(offset) {
    setPageNumber((prevPageNumber) => {
      const total = allPages || 1;
      return Math.min(Math.max(1, prevPageNumber + offset), total);
    });
    setShowInfoSidebar(false);
    setShowPagesSidebar(false);
  }

  useEffect(() => {
    const updateSize = () => {
      if (divRef.current) {
        const pdfWidth = pdfNewWidthFun(divRef);
        setPdfNewWidth(pdfWidth);
        setContainerWH({
          width: divRef.current.offsetWidth,
          height: divRef.current.offsetHeight,
        });
      }
    };

    // Initial size calculation
    updateSize();

    // Use ResizeObserver to handle dynamic size changes
    const resizeObserver = new ResizeObserver(() => {
      updateSize();
    });

    if (divRef.current) {
      resizeObserver.observe(divRef.current);
    }

    // Also update on window resize
    const handleResize = () => {
      setTimeout(updateSize, 100);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divRef.current]);

  // Auto-navigate to next widget when current widget is filled.
  // Use selectWidgetId (set when user clicks/focuses a field) — unSignedWidgetId is only set after
  // validation errors or programmatic navigation, so relying on it alone skips text inputs.
  useEffect(() => {
    if (signerPos.length > 0 && signerObjectId) {
      const checkUser = signerPos.filter(
        (data) => data.signerObjId === signerObjectId,
      );

      if (checkUser && checkUser.length > 0) {
        const activeWidgetKey = selectWidgetId ?? unSignedWidgetId;
        if (activeWidgetKey === undefined || activeWidgetKey === null) return;

        const currentWidget = checkUser[0].placeHolder
          ?.flatMap((placeholder) => placeholder.pos)
          ?.find((widget) => widget.key === activeWidgetKey);

        if (currentWidget) {
          const isFilled =
            currentWidget.options?.response ||
            currentWidget.pos?.SignUrl ||
            currentWidget.options?.defaultValue ||
            (currentWidget.type === "checkbox" &&
              currentWidget.options?.response?.length >=
                currentWidget.options?.validation?.minRequiredCount);

          if (isFilled) {
            const fromPage = checkUser[0].placeHolder.find((ph) =>
              ph.pos?.some((w) => w.key === activeWidgetKey),
            )?.pageNumber;
            const pageForNav =
              typeof fromPage === "number" ? fromPage : pageNumber;
            // Auto-navigate to next widget after a short delay (blur/change batching)
            const t = setTimeout(() => {
              findAndNavigateToNextWidget(activeWidgetKey, pageForNav);
            }, 350);
            return () => clearTimeout(t);
          }
        }
      }
    }
  }, [signerPos, signerObjectId, unSignedWidgetId, selectWidgetId, pageNumber]);

  //function for get pdf page details
  const pageDetails = async (pdf) => {
    let pdfWHObj = [];
    const totalPages = pdf.numPages; // Get the total number of pages
    setAllPages(totalPages);
    for (let index = 0; index < totalPages; index++) {
      const getPage = await pdf.getPage(index + 1);
      const scale = 1;
      const { width, height } = getPage.getViewport({ scale });
      pdfWHObj.push({ pageNumber: index + 1, width, height });
    }
    setPdfOriginalWH(pdfWHObj);
    setPdfLoad(true);
  };
  //function for save x and y position and show signature  tab on that position
  const handleTabDrag = (key) => {
    setDragKey(key);
    setIsDragging(true);
  };

  //function for set and update x and y postion after drag and drop signature tab
  const handleStop = (event, dragElement, signerId, key) => {
    if (!isResize && isDragging) {
      let updateSignPos = [...signerPos];
      const signerObjId = signerId ? signerId : uniqueId;
      const keyValue = key ? key : dragKey;
      const containerScale = getContainerScale(
        pdfOriginalWH,
        pageNumber,
        containerWH,
      );
      if (keyValue >= 0) {
        let filterSignerPos = [];
        if (signerObjId) {
          //get current signerObjId placeholder details
          filterSignerPos = updateSignPos.filter(
            (data) => data.Id === signerObjId,
          );
        }

        if (filterSignerPos.length > 0) {
          const getPlaceHolder = filterSignerPos[0].placeHolder;
          //get position of current pagenumber
          const getPageNumer = getPlaceHolder.filter(
            (data) => data.pageNumber === pageNumber,
          );
          if (getPageNumer.length > 0) {
            const getXYdata = getPageNumer[0].pos;
            const addSignPos = getXYdata.map((url) => {
              //add new position after drag widgets
              if (url.key === keyValue) {
                return {
                  ...url,
                  xPosition: dragElement.x / (containerScale * scale),
                  yPosition: dragElement.y / (containerScale * scale),
                };
              }
              return url;
            });
            //update new position of current page number
            const newUpdateSignPos = getPlaceHolder.map((obj) => {
              if (obj.pageNumber === pageNumber) {
                return { ...obj, pos: addSignPos };
              }
              return obj;
            });
            //update new placeholder of current signer
            const newUpdateSigner = updateSignPos.map((obj) => {
              if (signerObjId) {
                if (obj.Id === signerObjId) {
                  return { ...obj, placeHolder: newUpdateSignPos };
                }
              }
              return obj;
            });
            setSignerPos(newUpdateSigner);
          }
        }
      }
    }
    setTimeout(() => setIsDragging(false), 200);
  };

  //function for delete signature block
  const handleDeleteSign = (key, Id) => {
    const updateData = [];
    const filterSignerPos = signerPos.filter((data) => data.Id === Id);
    if (filterSignerPos.length > 0) {
      const getPlaceHolder = filterSignerPos[0].placeHolder;
      const getPageNumer = getPlaceHolder.filter(
        (data) => data.pageNumber === pageNumber,
      );
      if (getPageNumer.length > 0) {
        const getXYdata = getPageNumer[0].pos.filter(
          (data) => data.key !== key,
        );
        //condition to check on same has multiple widgets so do not delete all widgets
        if (getXYdata.length > 0) {
          updateData.push(getXYdata);
          const newUpdatePos = getPlaceHolder.map((obj) => {
            if (obj.pageNumber === pageNumber) {
              return { ...obj, pos: updateData[0] };
            }
            return obj;
          });

          const newUpdateSigner = signerPos.map((obj) => {
            if (obj.Id === Id) {
              return { ...obj, placeHolder: newUpdatePos };
            }
            return obj;
          });
          setSignerPos(newUpdateSigner);
        } else {
          const getRemainPage = filterSignerPos[0].placeHolder.filter(
            (data) => data.pageNumber !== pageNumber,
          );
          //condition to check placeholder length is greater than 1 do not need to remove whole placeholder
          //array only resove particular widgets
          if (getRemainPage && getRemainPage.length > 0) {
            const newUpdatePos = filterSignerPos.map((obj) => {
              if (obj.Id === Id) {
                return { ...obj, placeHolder: getRemainPage };
              }
              return obj;
            });
            let signerupdate = [];
            signerupdate = signerPos.filter((data) => data.Id !== Id);
            signerupdate.push(newUpdatePos[0]);
            setSignerPos(signerupdate);
          } else {
            const updatedData = signerPos.map((item) => {
              if (item.Id === Id) {
                // Create a copy of the item object and delete the placeHolder field
                const updatedItem = { ...item };
                delete updatedItem.placeHolder;
                return updatedItem;
              }
              return item;
            });
            setSignerPos(updatedData);
          }
        }
      }
    }
  };

  const handleTextSettingModal = (value) => {
    setIsTextSetting(value);
  };

  //function for setting position after drop signature button over pdf
  const addPositionOfSignature = (item, monitor) => {
    getSignerPos(item, monitor);
  };

  const getSignerPos = (item, monitor) => {
    const posZIndex = zIndex + 1;
    setZIndex(posZIndex);
    const key = randomId();
    const containerScale = getContainerScale(
      pdfOriginalWH,
      pageNumber,
      containerWH,
    );
    let dropData = [];
    let placeHolder;
    const dragTypeValue = item?.text ? item.text : monitor.type;
    const widgetWidth =
      defaultWidthHeight(dragTypeValue).width * containerScale;
    const widgetHeight =
      defaultWidthHeight(dragTypeValue).height * containerScale;
    //adding and updating drop position in array when user drop signature button in div
    if (item === "onclick") {
      const divHeight = divRef.current.getBoundingClientRect().height;
      // `getBoundingClientRect()` is used to get accurate measurement height of the div
      const dropObj = {
        //onclick put placeholder center on pdf
        xPosition: widgetWidth / 4 + containerWH.width / 2,
        yPosition: widgetHeight + divHeight / 2,
        isStamp:
          (dragTypeValue === "stamp" || dragTypeValue === "image") && true,
        key: key,
        scale: containerScale,
        zIndex: posZIndex,
        type: dragTypeValue,
        options: addWidgetOptions(dragTypeValue, owner),
        Width: widgetWidth / (containerScale * scale),
        Height: widgetHeight / (containerScale * scale),
      };
      dropData.push(dropObj);
      placeHolder = { pageNumber: pageNumber, pos: dropData };
    } else {
      const offset = monitor.getClientOffset();
      //This method returns the offset of the current pointer (mouse) position relative to the client viewport.
      const containerRect = document
        .getElementById("container")
        .getBoundingClientRect();
      //`containerRect.left`,  The distance from the left of the viewport to the left side of the element.
      //`containerRect.top` The distance from the top of the viewport to the top of the element.
      const x = offset.x - containerRect.left;
      const y = offset.y - containerRect.top;
      const getXPosition = signBtnPosition[0] ? x - signBtnPosition[0].xPos : x;
      const getYPosition = signBtnPosition[0] ? y - signBtnPosition[0].yPos : y;
      const dropObj = {
        xPosition: getXPosition / (containerScale * scale),
        yPosition: getYPosition / (containerScale * scale),
        isStamp:
          (dragTypeValue === "stamp" || dragTypeValue === "image") && true,
        key: key,
        scale: containerScale,
        zIndex: posZIndex,
        type: dragTypeValue,
        options: addWidgetOptions(dragTypeValue, owner),
        Width: widgetWidth / (containerScale * scale),
        Height: widgetHeight / (containerScale * scale),
      };
      dropData.push(dropObj);
      placeHolder = { pageNumber: pageNumber, pos: dropData };
    }
    setSelectWidgetId(key);
    if (uniqueId) {
      let filterSignerPos, currentPagePosition;
      filterSignerPos = signerPos.find((data) => data.Id === uniqueId);
      const getPlaceHolder = filterSignerPos?.placeHolder;
      if (getPlaceHolder) {
        //checking exist placeholder on same page
        currentPagePosition = getPlaceHolder.find(
          (data) => data.pageNumber === pageNumber,
        );
      }
      //checking current page has already some placeholders then update that placeholder and add upcoming placehoder position
      if (getPlaceHolder && currentPagePosition) {
        const updatePlace = getPlaceHolder.filter(
          (data) => data.pageNumber !== pageNumber,
        );
        const getPos = currentPagePosition?.pos;
        const newSignPos = getPos.concat(dropData);
        let xyPos = { pageNumber: pageNumber, pos: newSignPos };
        updatePlace.push(xyPos);
        const updatesignerPos = signerPos.map((x) =>
          x.Id === uniqueId ? { ...x, placeHolder: updatePlace } : x,
        );
        setSignerPos(updatesignerPos);
      } else {
        //else condition to add placeholder widgets on multiple page first time
        const updatesignerPos = signerPos.map((x) =>
          x.Id === uniqueId && x?.placeHolder
            ? { ...x, placeHolder: [...x.placeHolder, placeHolder] }
            : x.Id === uniqueId
              ? { ...x, placeHolder: [placeHolder] }
              : x,
        );
        setSignerPos(updatesignerPos);
      }

      // if (dragTypeValue === "dropdown") {
      //   setShowDropdown(true);
      // } else if (dragTypeValue === "checkbox") {
      //   setIsCheckbox(true);
      // } else
      if (
        [textWidget, "name", "company", "job title", "email"].includes(
          dragTypeValue,
        )
      ) {
        setFontSize(12);
        setFontColor("black");
      }
      setWidgetType(dragTypeValue);
      setSignKey(key);
      setCurrWidgetsDetails({});
    }
  };

  //function for image upload or update
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      // Check if the file is an image
      if (file.type.startsWith("image/")) {
        // Get widget dimensions for image resizing
        let widgetDimensions = null;
        if (currWidgetsDetails && currWidgetsDetails.type === "image") {
          widgetDimensions = {
            width: placeholderWidth(currWidgetsDetails),
            height: placeholderHeight(currWidgetsDetails),
          };
        }
        compressedFileSize(file, setImgWH, setImage, widgetDimensions);
      } else {
        toast.error("Please select an image file");
      }
    }
  };

  //function for upload stamp image
  const saveImage = () => {
    const widgetsType = currWidgetsDetails?.type;
    //get current signers placeholder position data
    const currentSigner = signerPos.filter(
      (data) => data.signerObjId === signerObjectId,
    );
    //get current pagenumber placeholder index
    const getIndex = currentSigner[0].placeHolder.findIndex((object) => {
      return object.pageNumber === pageNumber;
    });
    //get current signer placeholder position data
    const placeholderPosition = currentSigner[0].placeHolder;
    //`isApplyAll` is used when user edit stamp then updated signature apply all existing drawn signatures
    const isApplyAll = true;
    //function of save image and get updated position with image url
    const getUpdatePosition = onSaveImage(
      placeholderPosition,
      getIndex,
      signKey,
      imgWH,
      image,
      isAutoSign,
      widgetsType,
      isApplyAll,
    );

    //replace updated placeholder position with old data
    placeholderPosition.splice(
      0,
      placeholderPosition.length,
      ...getUpdatePosition,
    );
    //get current signers placeholder position data index number in array
    const indexofSigner = signerPos.findIndex((object) => {
      return object.signerObjId === signerObjectId;
    });
    //update current signers data with new placeholder position array data
    setSignerPos((prevState) => {
      const newState = [...prevState]; // Create a copy of the state
      newState.splice(indexofSigner, 1, ...currentSigner); // Modify the copy
      return newState; // Update the state with the modified copy
    });
    setIsAutoSign(false);

    // Auto-traverse to next widget after saving image
    setTimeout(() => {
      findAndNavigateToNextWidget(signKey, pageNumber);
    }, 500);
  };
  //function for save button to save signature or image url
  const saveSign = (type, isDefaultSign, width, height, typedSignature) => {
    const widgetsType = currWidgetsDetails?.type;
    const isTypeText = width && height ? true : false;
    const signatureImg = isDefaultSign
      ? isDefaultSign === "initials"
        ? myInitial
        : defaultSignImg
      : signature;
    let imgWH = { width: width ? width : "", height: height ? height : "" };
    setIsSignPad(false);
    setIsImageSelect(false);
    setImage();

    // console.log(signerPos, signerObjectId);
    //get current signers placeholder position data
    const currentSigner = signerPos.filter(
      (data) => data.signerObjId === signerObjectId,
    );

    // console.log("currentSigner", currentSigner);
    //get current pagenumber placeholder index
    const getIndex = currentSigner[0].placeHolder.findIndex((object) => {
      return object.pageNumber === pageNumber;
    });

    //set default signature image width and height
    if (isDefaultSign) {
      const img = new Image();
      img.src = defaultSignImg;
      if (img.complete) {
        imgWH = { width: img.width, height: img.height };
      }
    }
    //get current signer placeholder position data
    const placeholderPosition = currentSigner[0].placeHolder;
    //`isApplyAll` is used when user edit signature/initial then updated signature apply all existing drawn signatures
    const isApplyAll = true;
    //function of save signature image and get updated position with signature image url
    const getUpdatePosition = onSaveSign(
      type,
      placeholderPosition,
      getIndex,
      signKey,
      signatureImg,
      imgWH,
      isDefaultSign,
      isTypeText,
      typedSignature,
      isAutoSign,
      widgetsType,
      isApplyAll,
    );
    const updateSignerData = currentSigner.map((obj) => {
      if (obj.signerObjId === signerObjectId) {
        return { ...obj, placeHolder: getUpdatePosition };
      }
      return obj;
    });

    const index = signerPos.findIndex(
      (data) => data.signerObjId === signerObjectId,
    );
    setSignerPos((prevState) => {
      const newState = [...prevState];
      newState.splice(index, 1, ...updateSignerData);
      return newState;
    });

    setIsAutoSign(false);

    // Auto-traverse to next widget after saving signature
    setTimeout(() => {
      findAndNavigateToNextWidget(signKey, pageNumber);
    }, 500);
  };

  const embedWidgetsData = async () => {
    try {
      const checkUser = signerPos.filter(
        (data) => data.signerObjId === signerObjectId,
      );
      if (checkUser && checkUser.length > 0) {
        let checkboxExist,
          requiredRadio,
          showAlert = false,
          widgetKey,
          radioExist,
          requiredCheckbox,
          TourPageNumber; // `pageNumber` is used to check on which page user did not fill widget's data then change current pageNumber and show tour message on that page

        for (let i = 0; i < checkUser[0].placeHolder.length; i++) {
          for (let j = 0; j < checkUser[0].placeHolder[i].pos.length; j++) {
            //get current page
            const updatePage = checkUser[0].placeHolder[i]?.pageNumber;
            //checking checbox type widget
            checkboxExist =
              checkUser[0].placeHolder[i].pos[j].type === "checkbox";
            //checking radio button type widget
            radioExist =
              checkUser[0].placeHolder[i].pos[j].type === radioButtonWidget;
            //condition to check checkbox widget exist or not
            if (checkboxExist) {
              //get all required type checkbox
              requiredCheckbox = checkUser[0].placeHolder[i].pos.filter(
                (position) =>
                  !position.options?.isReadOnly && position.type === "checkbox",
              );
              //if required type checkbox data exit then check user checked all checkbox or some checkbox remain to check
              //also validate to minimum and maximum required checkbox
              if (requiredCheckbox && requiredCheckbox.length > 0) {
                for (let i = 0; i < requiredCheckbox.length; i++) {
                  //get minimum required count if  exit
                  const minCount =
                    requiredCheckbox[i].options?.validation?.minRequiredCount;
                  const parseMin = minCount && parseInt(minCount);
                  //get maximum required count if  exit
                  const maxCount =
                    requiredCheckbox[i].options?.validation?.maxRequiredCount;
                  const parseMax = maxCount && parseInt(maxCount);
                  //in `response` variable is used to get how many checkbox checked by user
                  const response =
                    requiredCheckbox[i].options?.response?.length;
                  //in `defaultValue` variable is used to get how many checkbox checked by default
                  const defaultValue =
                    requiredCheckbox[i].options?.defaultValue?.length;
                  //condition to check  parseMin  and parseMax greater than 0  then consider it as a required check box
                  if (
                    parseMin > 0 &&
                    parseMax > 0 &&
                    !response &&
                    !defaultValue &&
                    !showAlert
                  ) {
                    showAlert = true;
                    widgetKey = requiredCheckbox[i].key;
                    TourPageNumber = updatePage;
                    setminRequiredCount(parseMin);
                  }
                  //else condition to validate minimum required checkbox
                  else if (parseMin > 0 && (parseMin > response || !response)) {
                    if (!showAlert) {
                      showAlert = true;
                      widgetKey = requiredCheckbox[i].key;
                      TourPageNumber = updatePage;
                      setminRequiredCount(parseMin);
                    }
                  }
                }
              }
            }
            //condition to check radio widget exist or not
            else if (radioExist) {
              //get all required type radio button
              requiredRadio = checkUser[0].placeHolder[i].pos.filter(
                (position) =>
                  !position.options?.isReadOnly &&
                  position.type === radioButtonWidget,
              );
              //if required type radio data exit then check user checked all radio button or some radio remain to check
              if (requiredRadio && requiredRadio?.length > 0) {
                let checkSigned;
                for (let i = 0; i < requiredRadio?.length; i++) {
                  checkSigned = requiredRadio[i]?.options?.response;
                  if (!checkSigned) {
                    let checkDefaultSigned =
                      requiredRadio[i]?.options?.defaultValue;
                    if (!checkDefaultSigned && !showAlert) {
                      showAlert = true;
                      widgetKey = requiredRadio[i].key;
                      TourPageNumber = updatePage;
                      setminRequiredCount(null);
                    }
                  }
                }
              }
            }
            //else condition to check all type widget data fill or not except checkbox and radio button
            else {
              //get all required type widgets except checkbox and radio
              const requiredWidgets = checkUser[0].placeHolder[i].pos.filter(
                (position) =>
                  position.options?.status === "required" &&
                  position.type !== radioButtonWidget &&
                  position.type !== "checkbox",
              );
              if (requiredWidgets && requiredWidgets?.length > 0) {
                let checkSigned;
                for (let i = 0; i < requiredWidgets?.length; i++) {
                  checkSigned = requiredWidgets[i]?.options?.response;
                  if (!checkSigned) {
                    const checkSignUrl = requiredWidgets[i]?.pos?.SignUrl;
                    if (!checkSignUrl) {
                      let checkDefaultSigned =
                        requiredWidgets[i]?.options?.defaultValue;
                      if (!checkDefaultSigned && !showAlert) {
                        showAlert = true;
                        widgetKey = requiredWidgets[i].key;
                        TourPageNumber = updatePage;
                        setminRequiredCount(null);
                      }
                    }
                  }

                  // Additional validation for Text Input widgets with min/max length constraints
                  if (
                    requiredWidgets[i]?.type === textInputWidget &&
                    checkSigned
                  ) {
                    const minLength = requiredWidgets[i]?.options?.minLength;
                    const maxLength = requiredWidgets[i]?.options?.maxLength;
                    const responseLength = checkSigned.length;

                    // Validate min length constraint
                    if (
                      minLength &&
                      minLength !== "" &&
                      !isNaN(parseInt(minLength)) &&
                      responseLength < parseInt(minLength)
                    ) {
                      if (!showAlert) {
                        showAlert = true;
                        widgetKey = requiredWidgets[i].key;
                        TourPageNumber = updatePage;
                        setminRequiredCount(null);
                        toast.error(
                          `Text input must be at least ${minLength} characters long`,
                        );
                      }
                    }

                    // Validate max length constraint
                    if (
                      maxLength &&
                      maxLength !== "" &&
                      !isNaN(parseInt(maxLength)) &&
                      responseLength > parseInt(maxLength)
                    ) {
                      if (!showAlert) {
                        showAlert = true;
                        widgetKey = requiredWidgets[i].key;
                        TourPageNumber = updatePage;
                        setminRequiredCount(null);
                        toast.error(
                          `Text input cannot exceed ${maxLength} characters`,
                        );
                      }
                    }
                  }
                }
              }
            }
          }
          //when showAlert is true then break the loop and show alert to fill required data in widgets
          if (showAlert) {
            toast.error("Please fill all required fields");
            break;
          }

          // Additional validation for all Text Input widgets with min/max length constraints (including non-required ones)
          if (!showAlert) {
            for (let i = 0; i < checkUser[0].placeHolder.length; i++) {
              for (let j = 0; j < checkUser[0].placeHolder[i].pos.length; j++) {
                const widget = checkUser[0].placeHolder[i].pos[j];

                if (
                  widget?.type === textInputWidget &&
                  widget?.options?.response
                ) {
                  const minLength = widget?.options?.minLength;
                  const maxLength = widget?.options?.maxLength;
                  const responseLength = widget.options.response.length;

                  // Validate min length constraint
                  if (
                    minLength &&
                    minLength !== "" &&
                    !isNaN(parseInt(minLength)) &&
                    responseLength < parseInt(minLength)
                  ) {
                    showAlert = true;
                    widgetKey = widget.key;
                    TourPageNumber = checkUser[0].placeHolder[i]?.pageNumber;
                    setminRequiredCount(null);
                    toast.error(
                      `Text input "${
                        widget.options?.name || "Text Input"
                      }" must be at least ${minLength} characters long`,
                    );
                    break;
                  }

                  // Validate max length constraint
                  if (
                    maxLength &&
                    maxLength !== "" &&
                    !isNaN(parseInt(maxLength)) &&
                    responseLength > parseInt(maxLength)
                  ) {
                    showAlert = true;
                    widgetKey = widget.key;
                    TourPageNumber = checkUser[0].placeHolder[i]?.pageNumber;
                    setminRequiredCount(null);
                    toast.error(
                      `Text input "${
                        widget.options?.name || "Text Input"
                      }" cannot exceed ${maxLength} characters`,
                    );
                    break;
                  }
                }
              }
              if (showAlert) break;
            }
          }
        }
        if (checkboxExist && requiredCheckbox && showAlert) {
          setUnSignedWidgetId(widgetKey);
          setPageNumber(TourPageNumber);
        } else if (radioExist && showAlert) {
          setUnSignedWidgetId(widgetKey);
          setPageNumber(TourPageNumber);
        } else if (showAlert) {
          setUnSignedWidgetId(widgetKey);
          setPageNumber(TourPageNumber);
        } else {
          const currentRecipientRequiredAttachment =
            templateData?.recipients.find(
              (recipient) => recipient.contactId === signerObjectId,
            )?.requiredAttachment;
          // Check if document upload is required
          if (
            templateData?.documentRequired &&
            currentRecipientRequiredAttachment
          ) {
            setShowDocumentUploadModal(true);
          } else {
            // Show confirmation popup before proceeding with API calls
            setShowConfirmSignModal(true);
          }
        }
        // else {
        //   // `widgets` is Used to return widgets details with page number of current user
        //   const widgets = checkUser?.[0]?.placeHolder;
        //   let pdfArrBuffer;
        //   //`contractDocument` function used to get updated SignedUrl
        //   // to resolve issue of widgets get remove automatically when more than 1 signers try to sign doc at a time
        //   const documentData = await contractDocument(documentId);
        //   if (documentData && documentData.length > 0) {
        //     const url = documentData[0]?.SignedUrl || documentData[0]?.URL;
        //     //convert document url in array buffer format to use embed widgets in pdf using pdf-lib
        //     const arrayBuffer = await convertPdfArrayBuffer(url);
        //     if (arrayBuffer === "Error") {
        //       setHandleError("Error: invalid document!");
        //     } else {
        //       pdfArrBuffer = arrayBuffer;
        //     }
        //   } else if (
        //     documentData === "Error: Something went wrong!" ||
        //     (documentData.result && documentData.result.error)
        //   ) {
        //     if (documentData?.result?.error?.includes("deleted")) {
        //       setHandleError(t("document-deleted"));
        //     } else {
        //       setHandleError(t("something-went-wrong-mssg"));
        //     }
        //   } else {
        //     setHandleError("Document not Found!");
        //   }
        //   // Load a PDFDocument from the existing PDF bytes
        //   const existingPdfBytes = pdfArrBuffer;
        //   try {
        //     const pdfDoc = await PDFDocument.load(existingPdfBytes);
        //     const isSignYourSelfFlow = false;
        //     const extUserPtr = pdfDetails[0].ExtUserPtr;
        //     const HeaderDocId = extUserPtr?.HeaderDocId;
        //     //embed document's object id to all pages in pdf document
        //     if (!HeaderDocId) {
        //       if (!isDocId) {
        //         await embedDocId(pdfDoc, documentId, allPages);
        //       }
        //     }
        //     //embed multi signature in pdf
        //     const pdfBytes = await multiSignEmbed(
        //       widgets,
        //       pdfDoc,
        //       isSignYourSelfFlow,
        //       scale
        //     );
        //     // // console.log("pdfte", pdfBytes);
        //     //get ExistUserPtr object id of user class to get tenantDetails
        //     if (!pdfBytes?.error) {
        //       const objectId = pdfDetails?.[0]?.ExtUserPtr?.UserId?.objectId;
        //       //function for call to embed signature in pdf and get digital signature pdf
        //       const resSign = await signPdfFun(
        //         pdfBytes,
        //         documentId,
        //         signerObjectId,
        //         objectId,
        //         widgets
        //       );
        //       if (resSign && resSign.status === "success") {
        //         setPdfUrl(resSign.data);
        //         setIsSigned(true);
        //         setSignedSigners([]);
        //         setUnSignedSigners([]);
        //         const isSuccessRoute = pdfDetails?.[0]?.RedirectUrl
        //           ? false
        //           : window.location?.pathname?.includes("load");
        //         const updateDoc = await getDocumentDetails(
        //           documentId,
        //           true,
        //           isSuccessRoute
        //         );
        //         const index = pdfDetails?.[0]?.Signers.findIndex(
        //           (x) => x.objectId === signerObjectId
        //         );
        //         const newIndex = index + 1;
        //         const usermail = {
        //           Email: pdfDetails?.[0]?.Placeholders[newIndex]?.email || ""
        //         };
        //         const user = usermail?.Email
        //           ? usermail
        //           : pdfDetails?.[0]?.Signers[newIndex];
        //         if (sendmail !== "false" && sendInOrder) {
        //           const requestBody = pdfDetails?.[0]?.RequestBody;
        //           const requestSubject = pdfDetails?.[0]?.RequestSubject;
        //           if (user) {
        //             const expireDate = pdfDetails?.[0].ExpiryDate.iso;
        //             const newDate = new Date(expireDate);
        //             const localExpireDate = newDate.toLocaleDateString(
        //               "en-US",
        //               { day: "numeric", month: "long", year: "numeric" }
        //             );
        //             let senderEmail = pdfDetails?.[0]?.ExtUserPtr?.Email;
        //             let senderPhone = pdfDetails?.[0]?.ExtUserPtr?.Phone;
        //             const senderName = pdfDetails?.[0].ExtUserPtr.Name;
        //             const documentName = pdfDetails?.[0].Name;
        //             try {
        //               let url = `${localStorage.getItem(
        //                 "baseUrl"
        //               )}functions/sendmailv3`;
        //               const headers = {
        //                 "Content-Type": "application/json",
        //                 "X-Parse-Application-Id":
        //                   localStorage.getItem("parseAppId"),
        //                 sessionToken: localStorage.getItem("accesstoken")
        //               };
        //               const objectId = user?.objectId;
        //               const hostUrl = window.location.origin;
        //               //encode this url value `${pdfDetails?.[0].objectId}/${user.Email}/${objectId}` to base64 using `btoa` function
        //               let encodeBase64;
        //               if (objectId) {
        //                 encodeBase64 = btoa(
        //                   `${pdfDetails?.[0].objectId}/${user.Email}/${objectId}`
        //                 );
        //               } else {
        //                 encodeBase64 = btoa(
        //                   `${pdfDetails?.[0].objectId}/${user.Email}`
        //                 );
        //               }
        //               let signPdf = `${hostUrl}/login/${encodeBase64}`;
        //               const orgName = pdfDetails[0]?.ExtUserPtr.Company
        //                 ? pdfDetails[0].ExtUserPtr.Company
        //                 : "";
        //               let replaceVar;
        //               if (requestBody && requestSubject) {
        //                 const replacedRequestBody = requestBody.replace(
        //                   /"/g,
        //                   "'"
        //                 );
        //                 const htmlReqBody =
        //                   "<html><head><meta http-equiv='Content-Type' content='text/html; charset=UTF-8' /></head><body>" +
        //                   replacedRequestBody +
        //                   "</body> </html>";

        //                 const variables = {
        //                   document_title: documentName,
        //                   note: pdfDetails?.[0]?.Note,
        //                   sender_name: senderName,
        //                   sender_mail: senderEmail,
        //                   sender_phone: senderPhone,
        //                   receiver_name: user?.Name || "",
        //                   receiver_email: user.Email,
        //                   receiver_phone: user?.Phone || "",
        //                   expiry_date: localExpireDate,
        //                   company_name: orgName,
        //                   signing_url: `<a href=${signPdf} target=_blank>Sign here</a>`
        //                 };
        //                 replaceVar = replaceMailVaribles(
        //                   requestSubject,
        //                   htmlReqBody,
        //                   variables
        //                 );
        //               }
        //               const mailparam = {
        //                 note: pdfDetails?.[0]?.Note || "",
        //                 senderName: senderName,
        //                 senderMail: senderEmail,
        //                 title: documentName,
        //                 organization: orgName,
        //                 localExpireDate: localExpireDate,
        //                 sigingUrl: signPdf
        //               };
        //               let params = {
        //                 replyto: senderEmail || "",
        //                 extUserId: extUserId,
        //                 recipient: user.Email,
        //                 subject: replaceVar?.subject
        //                   ? replaceVar?.subject
        //                   : mailTemplate(mailparam).subject,
        //                 from: senderEmail,
        //                 html: replaceVar?.body
        //                   ? replaceVar?.body
        //                   : mailTemplate(mailparam).body
        //               };
        //               await axios.post(url, params, { headers: headers });
        //             } catch (error) {
        //               // console.log("error", error);
        //             }
        //           }
        //         }
        //         if (!isSuccessRoute) {
        //           setIsredirectCanceled(false);
        //         } else {
        //           const url =
        //             updateDoc?.[0]?.SignedUrl || updateDoc?.[0]?.URL;
        //           const fileAdapter = "";
        //           const isCompleted = updateDoc?.[0]?.IsCompleted
        //             ? `&completed=true`
        //             : "";
        //           const params = `docid=${
        //             updateDoc[0].objectId
        //           }&docurl=${encodeURIComponent(
        //             url
        //           )}${isCompleted}${fileAdapter}`;
        //           window.location.href = `/success?${params}`;
        //         }
        //       } else {
        //         setIsUiLoading(false);
        //         setIsAlert({
        //           title: "Error",
        //           isShow: true,
        //           alertMessage: resSign.message
        //         });
        //       }
        //     } else {
        //       setIsUiLoading(false);
        //       setIsAlert({
        //         title: "Error",
        //         isShow: true,
        //         alertMessage: t("pdf-uncompatible", { appName: appName })
        //       });
        //     }
        //   } catch (err) {
        //     setIsUiLoading(false);
        //     if (err && err.message.includes("is encrypted.")) {
        //       setIsAlert({
        //         isShow: true,
        //         alertMessage: t("encrypted-pdf-not-support")
        //       });
        //     } else {
        //       // console.log("err in request signing", err);
        //       setIsAlert({
        //         isShow: true,
        //         alertMessage: t("something-went-wrong-mssg")
        //       });
        //     }
        //   }
        // }
        setIsSignPad(false);
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      // console.log("err in embedsign", err);
      toast.error("Something went wrong");
    }
  };
  // console.log("signerPos", isSignPad);

  const handleOTPVerified = async () => {
    setShowOTPModal(false);
    setOtpVerified(true);
    // Re-fetch sign request to get updated status
    try {
      const response = await getSignRequestById(signReqId, userId);
      const updatedOtpVerified = response.otpVerified || false;
      setOtpVerified(updatedOtpVerified);
    } catch (error) {
      console.error("Error re-fetching sign request:", error);
    }
  };

  const handleConfirmSign = async () => {
    // Check if OTP verification is required and not yet verified
    if (requiresOtp && !otpVerified) {
      setShowOTPModal(true);
      return;
    }

    try {
      const checkUser = signerPos.filter(
        (data) => data.signerObjId === signerObjectId,
      );

      if (checkUser && checkUser.length > 0) {
        const widgets = checkUser[0].placeHolder;
        // console.log(checkUser);
        const existingPdfBytes = pdfArrayBuffer;

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        // console.log(widgets, "widgets");

        // one signature widget
        let signatureWidget = null;
        let signatureType = null;
        for (const widget of widgets) {
          const checkSignatureWidget = widget.pos.find(
            (pos) => pos.type === "signature",
          );
          if (checkSignatureWidget) {
            signatureWidget = checkSignatureWidget.SignUrl;
            // typeSignature = typed, signatureType = "draw" for drawn, "mysignature" for pre-selected
            signatureType = checkSignatureWidget.typeSignature
              ? "type"
              : checkSignatureWidget.signatureType || "draw";
            break;
          }
        }

        if (!templateData?.signUrl) {
          await embedDocId(pdfDoc, signReqId, allPages);
        }

        //embed multi signature in pdf
        const pdfBytes = await multiSignEmbed(widgets, pdfDoc, false, scale);

        if (!pdfBytes?.error) {
          showLoader();
          const response = await api.post(
            "/documents/upload/bytes",
            { data: pdfBytes, signRequestId: signReqId },
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );

          if (!response.data?.filePath) {
            throw new Error("Failed to upload document");
          }

          const result = response.data?.filePath;

          const signUrlResponse = await api.post(
            "/signRequests/capture-signurl",
            {
              signRequestId: signReqId,
              signUrl: result,
              contactId: userId,
              signBase64: signatureWidget,
              signatureType,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );

          // Validate response from capture-signurl
          if (!signUrlResponse.data || signUrlResponse.status !== 200) {
            throw new Error(
              signUrlResponse.data?.message ||
                "Failed to capture signature URL",
            );
          }

          // console.log("Server Response:", signUrlResponse);
          setSuccess(true);
        }
      }
    } catch (err) {
      // console.log("err in embedsign", err);
      const errorMsg =
        err?.response?.data?.message || err?.message || "Something went wrong";
      toast.error(errorMsg);
    } finally {
      hideLoader();
      setShowConfirmSignModal(false);
    }
  };

  const handleDecline = async () => {
    if (!declineReason.trim()) {
      setDeclineError("Please provide a reason for declining");
      return;
    }
    try {
      showLoader();
      await api.post(
        "/signRequests/decline",
        {
          signRequestId: signReqId,
          contactId: userId,
          reason: declineReason,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      window.location.reload();
      setShowDeclineModal(false);
      setDeclineReason("");
      setDeclineError("");
    } catch (err) {
      // console.log("err in decline", err);
      const errorMsg =
        err?.response?.data?.message || err?.message || "Something went wrong";
      toast.error(errorMsg);
    } finally {
      hideLoader();
    }
  };

  const handleDocumentUploadComplete = (response) => {
    // console.log("Document upload completed:", response);
    setShowDocumentUploadModal(false);
    // Show sign confirmation modal after successful upload
    setShowConfirmSignModal(true);
  };
  const headerDisplayName =
    signRequest?.name || templateData?.name || "Document";

  const getWidgetActionLabel = (type = "") => {
    const normalized = String(type).toLowerCase();
    if (normalized === "signature") return "Signature";
    if (normalized === "initials") return "Initials";
    // if (normalized === "date") return "Pick Date";
    // if (normalized === "text" || normalized === textWidget) return "Enter Text";
    // if (normalized === textInputWidget) return "Fill Field";
    // if (normalized === "checkbox") return "Select Option";
    // if (normalized === radioButtonWidget) return "Choose One";
    // if (normalized === "stamp") return "Add Stamp";
    // if (normalized === "image") return "Upload Image";
    return "Next";
  };

  const handleGoToNextWidgetFromTop = () => {
    const currentSigner = signerPos.find(
      (item) => item.signerObjId === signerObjectId,
    );
    const placeholders = currentSigner?.placeHolder || [];

    const orderedWidgets = placeholders
      .flatMap((placeholder) =>
        (placeholder?.pos || []).map((widget) => ({
          ...widget,
          pageNumber: placeholder.pageNumber,
        })),
      )
      .filter((widget) => typeof widget?.yPosition === "number")
      .sort((a, b) => {
        if (a.pageNumber !== b.pageNumber) return a.pageNumber - b.pageNumber;
        return a.yPosition - b.yPosition;
      });

    if (!orderedWidgets.length) return;

    const nextIndex = (nextWidgetIndex + 1) % orderedWidgets.length;
    const nextWidget = orderedWidgets[nextIndex];
    setNextWidgetIndex(nextIndex);
    setNextButtonLabel(getWidgetActionLabel(nextWidget.type));

    setUnSignedWidgetId(nextWidget.key);
    setSelectWidgetId(nextWidget.key);
    setPageNumber(nextWidget.pageNumber);

    const scrollToWidget = () => {
      if (!divRef.current) return false;
      const widgetEl = document.getElementById(String(nextWidget.key));

      const containerScale = getContainerScale(
        pdfOriginalWH,
        nextWidget.pageNumber,
        containerWH,
      );
      if (widgetEl) {
        widgetEl.scrollIntoView({ behavior: "smooth", block: "center" });
        return true;
      }

      const targetY = Math.max(
        0,
        nextWidget.yPosition * containerScale * scale,
      );
      divRef.current.scrollTo({ top: targetY, behavior: "smooth" });
      divRef.current.scrollTop = targetY;
      return false;
    };

    // Retry a few times so it still works right after page switches/rerenders.
    const retryDelays = [80, 180, 320, 520];
    retryDelays.forEach((delay) => {
      setTimeout(() => {
        scrollToWidget();
      }, delay);
    });
  };

  return (
    <div>
      {success && (
        <div className="min-h-screen flex items-center justify-center p-4 bg-white relative">
          <img
            src="/Logo_EzSignly.png"
            alt="EzSignly Logo"
            className="absolute top-4 left-4 h-9 w-auto"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="bg-white rounded-2xl w-full max-w-lg border border-gray-100 p-8"
          >
            <div className="text-center">
              {/* Success Icon with Animation */}
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{
                  duration: 0.5,
                  delay: 0.2,
                  type: "spring",
                  stiffness: 200,
                  damping: 15,
                }}
                className="mx-auto mb-6 w-20 h-20 bg-green-100 rounded-full flex items-center justify-center"
              >
                <CheckCircleIcon className="w-12 h-12 text-green-600" />
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.3 }}
                className="text-lg font-bold text-gray-900 mb-3 font-dm-sans"
              >
                Document Signed Successfully!
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.3 }}
                className="text-gray-600 text-sm leading-relaxed mb-8"
              >
                Your document has been successfully signed and processed.
              </motion.p>
            </div>
          </motion.div>
        </div>
      )}
      {hasError && (
        <div className="min-h-screen flex items-center justify-center p-4 bg-white relative">
          <img
            src="/Logo_EzSignly.png"
            alt="EzSignly Logo"
            className="absolute top-4 left-4 h-9 w-auto"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="bg-white rounded-2xl w-full max-w-lg border border-gray-100 p-8"
          >
            <div className="text-center">
              {/* Error Icon with Animation */}
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{
                  duration: 0.5,
                  delay: 0.2,
                  type: "spring",
                  stiffness: 200,
                  damping: 15,
                }}
                className={`mx-auto mb-6 w-20 h-20 ${
                  templateData?.status === "COMPLETED"
                    ? "bg-green-100"
                    : "bg-red-100"
                } rounded-full flex items-center justify-center`}
              >
                {templateData?.status === "COMPLETED" ? (
                  <CheckCircleIcon className="w-12 h-12 text-green-600" />
                ) : (
                  <ExclamationTriangleIcon className="w-12 h-12 text-red-600" />
                )}
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.3 }}
                className="text-lg font-bold text-gray-900 mb-3 font-dm-sans"
              >
                {templateData?.status === "COMPLETED"
                  ? "Document Already Completed"
                  : "Oops!"}
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.3 }}
                className="text-gray-600 text-sm leading-relaxed mb-8"
              >
                {templateData?.status === "COMPLETED"
                  ? "This document has already been completed and signed by all parties."
                  : error ||
                    "Something went wrong while processing your request."}
              </motion.p>

              {templateData?.status === "COMPLETED" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6, duration: 0.3 }}
                  className="mt-4"
                >
                  <Button
                    variant="primary"
                    size="default"
                    fullWidth
                    rightIcon={ArrowDownTrayIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      try {
                        if (!templateData?.signUrl) return;
                        const signedUrl = await getSignedUrl(
                          templateData.signUrl,
                        );
                        // Mobile: same tab only — reliable after async.
                        const useSameTab =
                          /iPhone|iPad|iPod|Android/i.test(
                            navigator.userAgent,
                          ) || window.matchMedia("(max-width: 768px)").matches;
                        if (useSameTab) {
                          window.location.assign(signedUrl);
                          return;
                        }
                        // Desktop: open exactly one new tab. Avoid `window.open` after async plus
                        // `location.assign` fallback — that combination can load the URL twice.
                        const a = document.createElement("a");
                        a.href = signedUrl;
                        a.target = "_blank";
                        a.rel = "noopener noreferrer";
                        a.style.display = "none";
                        document.body.appendChild(a);
                        a.click();
                        requestAnimationFrame(() => {
                          document.body.removeChild(a);
                        });
                      } catch (err) {
                        console.error("Error fetching signed URL:", err);
                        toast.error("Failed to open document");
                      }
                    }}
                  >
                    Download Document
                  </Button>
                </motion.div>
              )}
            </div>
          </motion.div>
        </div>
      )}
      {isLoading && !hasError ? (
        <div className="min-h-screen flex items-center justify-center p-4 bg-white relative">
          <img
            src="/Logo_EzSignly.png"
            alt="EzSignly Logo"
            className="absolute top-4 left-4 h-9 w-auto"
          />
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25 }}
            className="bg-white rounded-2xl w-full max-w-md border border-gray-100 p-7"
          >
            <div className="text-center">
              {/* Subtle loading indicator */}
              <div className="mx-auto mb-5 w-10 h-10 rounded-full border-2 border-gray-200 border-t-primary animate-spin" />

              <h1 className="text-lg font-semibold text-gray-900 mb-2 font-dm-sans">
                Loading Document
              </h1>
              <p className="text-sm text-gray-500 leading-relaxed">
                Please wait while we prepare your document for signing...
              </p>
            </div>
          </motion.div>
        </div>
      ) : (
        !hasError &&
        !success && (
          <div className="h-screen overflow-hidden">
            {/* Mobile Header */}
            <div className="md:hidden fixed top-0 left-0 right-0 z-30 bg-primary border-b border-primary/80 px-3 py-2">
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-medium text-white min-w-0 flex-1 truncate">
                  {headerDisplayName}
                </p>
                <div className="relative shrink-0">
                  <div className="inline-flex rounded-lg overflow-hidden">
                    <Button
                      size="default"
                      onClick={embedWidgetsData}
                      className="bg-yellow !text-black font-bold rounded-r-none hover:bg-yellow transition-colors"
                    >
                      Submit
                    </Button>
                    <button
                      type="button"
                      onClick={() => setShowDesktopActionMenu((prev) => !prev)}
                      className="px-2 text-black bg-yellow border-l border-black/20 focus:outline-none"
                    >
                      <ChevronDownIcon className="h-4 w-4 text-black" />
                    </button>
                  </div>
                  {showDesktopActionMenu && (
                    <div className="absolute right-0 mt-2 w-40 rounded-lg border border-gray-200 bg-white shadow-lg overflow-hidden">
                      <button
                        type="button"
                        onClick={() => {
                          setShowDesktopActionMenu(false);
                          setShowDeclineModal(true);
                        }}
                        className="w-full px-4 py-2 text-left text-sm font-medium text-red-600 hover:bg-red-50"
                      >
                        Decline
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Desktop Header */}
            <div className="hidden md:flex fixed top-0 left-0 right-0 z-30 border-b border-primary/80 bg-primary py-2 px-6 justify-between items-center">
              <div className="flex items-center gap-3">
                <p className="text-sm font-medium text-white max-w-[220px] truncate">
                  {headerDisplayName}
                </p>
              </div>
              <div className="relative">
                <div className="inline-flex rounded-lg overflow-hidden">
                  <Button
                    size="default"
                    onClick={embedWidgetsData}
                    className="bg-yellow !text-black font-bold rounded-r-none hover:bg-yellow transition-colors !px-[2.5rem] !py-2.5"
                  >
                    Submit
                  </Button>
                  <button
                    type="button"
                    onClick={() => setShowDesktopActionMenu((prev) => !prev)}
                    className="px-2 text-black bg-yellow border-l border-black/20 focus:outline-none"
                  >
                    <ChevronDownIcon className="h-4 w-4" />
                  </button>
                </div>
                {showDesktopActionMenu && (
                  <div className="absolute right-0 mt-2 w-40 rounded-lg border border-gray-200 bg-white shadow-lg overflow-hidden">
                    <button
                      type="button"
                      onClick={() => {
                        setShowDesktopActionMenu(false);
                        setShowDeclineModal(true);
                      }}
                      className="w-full px-4 py-2 text-left text-sm font-medium text-red-600 hover:bg-red-50"
                    >
                      Decline
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="rounded-none md:rounded-lg shadow-sm bg-gray-100 relative overflow-hidden flex flex-col md:flex-row justify-between h-[calc(100vh-98px)] mt-14">
              {/* Desktop Sidebar */}
              {/* <div className="hidden md:block w-[23%] bg-base-100 h-screen overflow-y-auto hide-scrollbar bg-slate-50 border-r border-gray-200">
                <div className="flex flex-col gap-4 px-4 py-6">
                  {templateData?.recipients?.map(
                    (item) =>
                      !item?.isCC && (
                        <div
                          key={item.id}
                          className="flex flex-row items-center gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
                        >
                          <div
                            className={`w-10 h-10 rounded-full ${item.color} flex items-center justify-center text-white font-semibold`}
                          >
                            {item.name.charAt(0)}
                          </div>
                          <div className="flex flex-col">
                            <div className="text-md font-semibold text-gray-800">
                              {item.name}
                            </div>
                            <div className="text-sm text-gray-500">
                              {item.email}
                            </div>
                          </div>
                        </div>
                      )
                  )}
                </div>
              </div> */}

              {/* PDF Viewer */}
              <div className="w-full md:w-[50%] flex mx-auto h-full bg-white relative">
                <button
                  type="button"
                  onClick={handleGoToNextWidgetFromTop}
                  className="hidden md:inline-flex absolute min-w-[100px] text-center -left-10 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20 items-center justify-center bg-yellow text-black text-xs font-medium px-3 py-2"
                >
                  {nextButtonLabel}
                </button>
                {/* Blocking overlay when OTP is required but not verified */}
                {requiresOtp && !otpVerified && (
                  <div className="absolute inset-0 bg-white/90 backdrop-blur-sm z-50 flex items-center justify-center">
                    <div className="text-center px-6">
                      <div className="w-12 h-12 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                      <p className="text-gray-800 font-medium">
                        OTP verification required
                      </p>
                      <p className="text-gray-500 text-sm mt-2">
                        Please verify your identity to continue
                      </p>
                    </div>
                  </div>
                )}
                <div className="w-full h-full flex">
                  <div
                    ref={divRef}
                    data-tut="pdfArea"
                    className={`h-full w-full overflow-y-auto overflow-x-hidden pb-32 md:pb-0 ${
                      requiresOtp && !otpVerified
                        ? "pointer-events-none opacity-50"
                        : ""
                    }`}
                  >
                    {containerWH && pdfBase64Url ? (
                      <RenderPdf
                        setIsPageCopy={setIsPageCopy}
                        drop={drop}
                        pageNumber={pageNumber}
                        pdfOriginalWH={pdfOriginalWH}
                        pdfNewWidth={pdfNewWidth}
                        setIsSignPad={setIsSignPad}
                        setIsStamp={setIsStamp}
                        setSignKey={setSignKey}
                        pdfDetails={templateData}
                        signerPos={signerPos}
                        successEmail={false}
                        pdfUrl={
                          templateData?.signUrl ||
                          templateData?.documentId?.path ||
                          ""
                        }
                        numPages={1}
                        pageDetails={pageDetails}
                        pdfRequest={true}
                        signerObjectId={signerObjectId}
                        signedSigners={signedSigners}
                        setPdfLoad={setPdfLoad}
                        pdfLoad={pdfLoad}
                        setSignerPos={(value) => {
                          setSignerPos(value);
                        }}
                        containerWH={containerWH}
                        setIsInitial={setIsInitial}
                        setValidateAlert={setValidateAlert}
                        unSignedWidgetId={unSignedWidgetId}
                        setSelectWidgetId={setSelectWidgetId}
                        selectWidgetId={selectWidgetId}
                        setCurrWidgetsDetails={setCurrWidgetsDetails}
                        divRef={divRef}
                        setIsResize={setIsResize}
                        isResize={isResize}
                        setScale={setScale}
                        scale={scale}
                        uniqueId={uniqueId}
                        pdfBase64Url={pdfBase64Url}
                        setIsAgreeTour={() => {}}
                        isAgree={isAgree}
                        handleTabDrag={handleTabDrag}
                        handleStop={handleStop}
                        isDragging={isDragging}
                        isAlllowModify={false}
                        setUniqueId={setUniqueId}
                        handleDeleteSign={handleDeleteSign}
                        handleTextSettingModal={handleTextSettingModal}
                        setWidgetType={setWidgetType}
                        assignedWidgetId={assignedWidgetId}
                        setRequestSignTour={setRequestSignTour}
                        openDateModal={openDateModal}
                      />
                    ) : (
                      <div className="flex flex-col items-center justify-center h-full">
                        <div className="w-12 h-12 border-2 border-primary border-t-transparent rounded-full animate-spin mb-4" />
                        <p className="text-gray-700 font-medium">
                          Preparing document...
                        </p>
                        {!containerWH && (
                          <p className="text-gray-500 text-sm mt-2">
                            Calculating layout...
                          </p>
                        )}
                        {!pdfBase64Url && (
                          <p className="text-gray-500 text-sm mt-2">
                            Loading PDF data...
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>{" "}
              </div>

              {/* Desktop Pages Sidebar */}
              <div className="hidden md:flex fixed right-0 top-1/2 -translate-y-1/2 z-20 w-20 rounded-xl border h-full justify-center border-gray-200 bg-white shadow-sm flex-col items-center py-3 gap-3">
                <button
                  type="button"
                  onClick={() => setShowInfoSidebar(true)}
                  className="w-10 h-10 rounded-lg border border-gray-200 text-black hover:bg-gray-50 flex items-center justify-center"
                  title="Recipients"
                >
                  <UsersIcon className="w-5 h-5" />
                </button>
                <button
                  type="button"
                  onClick={() => setShowPagesSidebar(true)}
                  className="w-10 h-10 rounded-lg border border-gray-200 text-black hover:bg-gray-50 flex items-center justify-center"
                  title="Pages"
                >
                  <DocumentTextIcon className="w-5 h-5" />
                </button>
                <button
                  type="button"
                  onClick={() => changePage(-1)}
                  disabled={pageNumber <= 1}
                  className="w-10 h-10 rounded-lg border border-gray-200 text-black hover:bg-gray-50 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed"
                  title="Previous page"
                >
                  <ChevronUpIcon className="w-5 h-5" />
                </button>
                <span className="text-[11px] font-medium text-black">
                  {pageNumber}/{allPages || 1}
                </span>
                <button
                  type="button"
                  onClick={() => changePage(1)}
                  disabled={!allPages || pageNumber >= allPages}
                  className="w-10 h-10 rounded-lg border border-gray-200 text-black hover:bg-gray-50 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed"
                  title="Next page"
                >
                  <ChevronDownIcon className="w-5 h-5" />
                </button>
              </div>

              {/* Mobile: same controls as desktop right sidebar */}
              <div className="md:hidden fixed left-0 right-0 z-40 bottom-[3.25rem] border-t border-gray-200 bg-white/95 backdrop-blur-sm shadow-[0_-4px_12px_rgba(0,0,0,0.06)] px-2 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
                <div className="flex flex-wrap items-center justify-center gap-2 max-w-2xl mx-auto">
                  <button
                    type="button"
                    onClick={() => setShowInfoSidebar(true)}
                    className="h-10 w-10 shrink-0 rounded-xl border border-gray-200 bg-white text-gray-800 hover:bg-gray-50 flex items-center justify-center"
                    title="Recipients"
                    aria-label="Recipients"
                  >
                    <UsersIcon className="w-5 h-5" />
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowPagesSidebar(true)}
                    className="h-10 w-10 shrink-0 rounded-xl border border-gray-200 bg-white text-gray-800 hover:bg-gray-50 flex items-center justify-center"
                    title="Pages"
                    aria-label="Pages"
                  >
                    <DocumentTextIcon className="w-5 h-5" />
                  </button>
                  <div className="flex items-center gap-1 shrink-0 border-l border-gray-200 pl-2 ml-0.5">
                    <button
                      type="button"
                      onClick={() => changePage(-1)}
                      disabled={!allPages || pageNumber <= 1}
                      className="h-10 w-10 rounded-xl border border-gray-200 bg-white text-gray-800 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
                      title="Previous page"
                      aria-label="Previous page"
                    >
                      <ChevronUpIcon className="w-5 h-5" />
                    </button>
                    <span
                      className="h-10 min-w-[2.75rem] flex items-center justify-center text-xs font-semibold text-gray-800 tabular-nums px-2"
                      aria-live="polite"
                    >
                      {pageNumber}/{allPages || 1}
                    </span>
                    <button
                      type="button"
                      onClick={() => changePage(1)}
                      disabled={!allPages || pageNumber >= allPages}
                      className="h-10 w-10 rounded-xl border border-gray-200 bg-white text-gray-800 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
                      title="Next page"
                      aria-label="Next page"
                    >
                      <ChevronDownIcon className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Fixed Footer */}
              <footer className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-gray-200 py-2 px-4">
                <div className="flex items-center gap-4">
                  <img
                    src="/Logo_EzSignly.png"
                    alt="EzSignly"
                    className="h-7 w-auto"
                  />
                  <p className="text-[11px] text-gray-500">
                    EzSignly © {new Date().getFullYear()} All rights reserved.
                  </p>
                </div>
              </footer>

              {/* Mobile Info Sidebar */}
              {showInfoSidebar && (
                <div className="fixed inset-0 z-50">
                  <div
                    className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                    onClick={() => setShowInfoSidebar(false)}
                  />
                  <div className="absolute right-0 top-0 h-full w-80 max-w-[85vw] bg-white shadow-2xl border-l border-gray-200 animate-sidebar-in">
                    <div className="flex justify-between items-center px-4 py-4 border-b border-gray-200 bg-gray-50/50">
                      <h3 className="font-semibold text-gray-900">
                        Recipients
                      </h3>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => setShowInfoSidebar(false)}
                        className="!p-2 rounded-lg"
                      >
                        <XMarkIcon className="w-5 h-5" />
                      </Button>
                    </div>
                    <div className="flex flex-col gap-3 p-4 overflow-y-auto h-[calc(100%-60px)]">
                      {templateData?.recipients?.map((item) => (
                        <div
                          key={item.id}
                          className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl border border-gray-100"
                        >
                          <div
                            className={`w-10 h-10 rounded-full ${item.color} flex items-center justify-center text-white font-semibold shrink-0`}
                          >
                            {item.name?.charAt(0) || "?"}
                          </div>
                          <div className="min-w-0 flex-1">
                            <div className="font-medium text-gray-800 truncate">
                              {item.name}
                            </div>
                            <div className="text-sm text-gray-500 truncate">
                              {item.email}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Mobile Pages Sidebar */}
              {showPagesSidebar && (
                <div className="fixed inset-0 z-50">
                  <div
                    className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                    onClick={() => setShowPagesSidebar(false)}
                  />
                  <div className="absolute right-0 top-0 h-full w-80 max-w-[85vw] bg-white shadow-2xl border-l border-gray-200 animate-sidebar-in">
                    <div className="flex justify-between items-center px-4 py-4 border-b border-gray-200 bg-gray-50/50">
                      <h3 className="font-semibold text-gray-900">Pages</h3>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => setShowPagesSidebar(false)}
                        className="!p-2 rounded-lg"
                      >
                        <XMarkIcon className="w-5 h-5" />
                      </Button>
                    </div>
                    <div className="overflow-y-auto h-[calc(100%-60px)]">
                      <RenderAllPdfPage
                        from="mobile"
                        signerPos={signerPos}
                        id={userId}
                        allPages={allPages}
                        setAllPages={setAllPages}
                        setPageNumber={setPageNumber}
                        pageNumber={pageNumber}
                        containerWH={containerWH}
                        pdfBase64Url={pdfBase64Url}
                        signedUrl={
                          templateData?.signUrl ||
                          templateData?.documentId?.path ||
                          ""
                        }
                        changePage={changePage}
                      />
                    </div>
                  </div>
                </div>
              )}

              {isSignPad && (
                <SignPad
                  saveSignCheckbox={saveSignCheckbox}
                  setSaveSignCheckbox={setSaveSignCheckbox}
                  signatureTypes={signatureType}
                  isSignPad={isSignPad}
                  isStamp={isStamp}
                  setIsImageSelect={setIsImageSelect}
                  setIsSignPad={setIsSignPad}
                  setImage={setImage}
                  isImageSelect={isImageSelect}
                  imageRef={imageRef}
                  onImageChange={onImageChange}
                  setSignature={setSignature}
                  image={image}
                  onSaveImage={saveImage}
                  onSaveSign={saveSign}
                  defaultSign={defaultSignImg}
                  myInitial={myInitial}
                  setDefaultSignImg={setDefaultSignImg}
                  setMyInitial={setMyInitial}
                  isInitial={isInitial}
                  setIsInitial={setIsInitial}
                  setIsStamp={setIsStamp}
                  currWidgetsDetails={currWidgetsDetails}
                  setCurrWidgetsDetails={setCurrWidgetsDetails}
                  setIsAutoSign={setIsAutoSign}
                  isAutoSign={isAutoSign}
                  userDetails={
                    signerPos?.find((item) => item.contactId === userId) || null
                  }
                />
              )}
            </div>
          </div>
        )
      )}
      <AnimatedModal
        isOpen={showDeclineModal}
        onClose={() => setShowDeclineModal(false)}
        closeOnBackdrop
        zIndex="z-[9999]"
        contentClassName="bg-white overflow-hidden shadow-xl border border-gray-100 max-w-lg w-full"
      >
        <div className="px-4 pt-5 pb-4 sm:p-6">
          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
            </div>
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
              <h3 className="text-lg font-medium text-gray-900">
                Decline Document
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500 mb-4">
                  Please provide a reason for declining this document:
                </p>
                <textarea
                  value={declineReason}
                  onChange={(e) => {
                    setDeclineReason(e.target.value);
                    if (e.target.value.trim()) setDeclineError("");
                  }}
                  className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary ${
                    declineError ? "border-red-500" : "border-gray-300"
                  }`}
                  rows={4}
                  placeholder="Enter your reason for declining..."
                />
                {declineError && (
                  <p className="mt-1 text-sm text-red-500">{declineError}</p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 px-4 py-3 flex flex-col-reverse gap-3 sm:px-6 sm:flex-row-reverse">
          <Button
            type="button"
            variant="danger"
            size="default"
            fullWidth
            className="sm:w-auto"
            onClick={handleDecline}
            disabled={!declineReason.trim()}
          >
            Decline Document
          </Button>
          <Button
            type="button"
            variant="outline"
            size="default"
            fullWidth
            className="sm:w-auto"
            onClick={() => setShowDeclineModal(false)}
          >
            Cancel
          </Button>
        </div>
      </AnimatedModal>

      {/* Date Picker Modal */}
      <DatePickerModal
        isOpen={isDateModalOpen}
        onClose={closeDateModal}
        selectedDate={dateModalData.selectedDate}
        onDateChange={dateModalData.onDateChange}
        dateFormat={dateModalData.dateFormat}
        fontSize={dateModalData.fontSize}
        fontColor={dateModalData.fontColor}
        allowPastDates={dateModalData.allowPastDates}
      />

      {/* Document Upload Modal */}
      <DocumentUploadModal
        isOpen={showDocumentUploadModal}
        onClose={() => setShowDocumentUploadModal(false)}
        onUploadComplete={handleDocumentUploadComplete}
        signRequestId={signReqId}
        recipientContactId={userId}
        documentRequiredMessage={templateData?.documentRequiredMessage}
      />

      {/* Confirm Sign Modal */}
      <AnimatedModal
        isOpen={showConfirmSignModal}
        onClose={() => setShowConfirmSignModal(false)}
        closeOnBackdrop
        zIndex="z-[9999]"
        contentClassName="bg-white overflow-hidden shadow-xl border border-gray-100 max-w-lg w-full"
      >
        <div className="px-4 pt-5 pb-4 sm:p-6">
          <img
            src="/Logo_EzSignly.png"
            alt="EzSignly"
            className="h-10 w-auto mb-4"
          />
          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 sm:mx-0 sm:h-10 sm:w-10">
              <DocumentTextIcon className="h-6 w-6 text-primary" />
            </div>
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
              <h3 className="text-lg font-medium text-gray-900">
                Confirm Document Signing
              </h3>
              <p className="mt-2 text-sm text-gray-500">
                Are you sure you want to sign this document? This action cannot
                be undone.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 px-4 py-3 flex flex-col-reverse gap-3 sm:px-6 sm:flex-row-reverse">
          <Button
            type="button"
            variant="primary"
            size="default"
            fullWidth
            className="sm:w-auto"
            onClick={handleConfirmSign}
            leftIcon={CheckCircleIcon}
          >
            Confirm & Sign
          </Button>
          <Button
            type="button"
            variant="outline"
            size="default"
            fullWidth
            className="sm:w-auto"
            onClick={() => setShowConfirmSignModal(false)}
          >
            Cancel
          </Button>
        </div>
      </AnimatedModal>

      {/* OTP Verification Modal */}
      <OTPVerificationModal
        isOpen={showOTPModal}
        onClose={() => setShowOTPModal(false)}
        onVerified={handleOTPVerified}
        signRequestId={signReqId}
        contactId={userId}
        phoneNumber={recipientPhone}
      />
    </div>
  );
};

export default SignDocument;
